export function invariant(
  cond?: boolean,
  message?: string,
  ..._args: string[]
): asserts cond {
  if (cond) {
    return;
  }

  throw new Error(
    // biome-ignore lint/style/useTemplate: <explanation>
    "Internal Lexical error: invariant() is meant to be replaced at compile " +
      "time. There is no runtime version. Error: " +
      message,
  );
}
